import * as React from 'react';

import { compose } from 'recompose';

import Retracked from 'js/app/retracked';

import { Grid } from '@coursera/cds-core';

import Markdown from 'bundles/cms/components/Markdown';
import PersonalizedEmbeddedMsg from 'bundles/degree-description/components/modules/personalization/PersonalizedEmbeddedMsg';
import { getCtaActionXddp, getMessagesToDisplay } from 'bundles/degree-description/utils/personalizedMessageCriteria';
import CareersPageSchemaMarkup from 'bundles/xddp/components/seo/CareersPageSchemaMarkup';
import Container from 'bundles/xddp/components/shared/Container';
import InfoSidebar from 'bundles/xddp/components/shared/InfoSidebar';
import { useScrollToStickyBar } from 'bundles/xddp/hooks/useScrollToStickyBar';
import type { DegreeSubPageProps } from 'bundles/xddp/types';

import 'css!bundles/xddp/components/__styles__/CareersPage';

const CareersPage: React.FC<DegreeSubPageProps> = (props) => {
  const { pageContent, userAgent, personalizedDdpData, handlePersonalizedRequestInfoClick, isStickyBarPresent } = props;
  const {
    careerOutcome,
    careerServices,
    atAGlance,
    programName,
    partnerInformation,
    expressionOfInterestContainer,
    slug,
  } = pageContent;

  const messagesToDisplay = getMessagesToDisplay(
    personalizedDdpData,
    slug,
    programName,
    partnerInformation?.partnerName
  );
  const embeddedAction = getCtaActionXddp(
    messagesToDisplay?.embeddedMessageToDisplay?.ctaActionType,
    expressionOfInterestContainer?.applyButtonUrl ?? expressionOfInterestContainer?.hostedApplicationUrl,
    handlePersonalizedRequestInfoClick
  );

  useScrollToStickyBar(isStickyBarPresent);

  return (
    <div className="rc-CareersPage">
      <CareersPageSchemaMarkup pageContent={pageContent} />
      <Container>
        <Grid container>
          <Grid item md={8}>
            <Markdown className="career-outcome rc-Section" source={careerOutcome} />
            {messagesToDisplay.embeddedMessageToDisplay && (
              <PersonalizedEmbeddedMsg
                personalizedMessage={messagesToDisplay.embeddedMessageToDisplay}
                ctaAction={embeddedAction}
                onXddp
              />
            )}
            <Markdown className="career-services rc-Section" source={careerServices} />
          </Grid>
          <InfoSidebar userAgent={userAgent} atAGlance={atAGlance} />
        </Grid>
      </Container>
    </div>
  );
};

export default compose<DegreeSubPageProps, DegreeSubPageProps>(
  Retracked.createTrackedContainer(() => ({
    namespace: {
      app: 'xddp',
      page: 'careers_page',
    },
  }))
)(CareersPage);
